import useSWR from 'swr';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { OrderService } from '../api';
import { UseAuthPermissions } from '../session/UseAuthPermissions';

export const OPEN_BALANCES_SUMMARY_KEY = 'openBalancesSummary';

export const useOpenBalancesSummary = () => {
  const { readOnly } = UseAuthPermissions();
  const openBillsEnabled = useFeatureFlagEnabled('feature-open-bills');
  const { data, mutate } = useSWR(
    readOnly || !openBillsEnabled ? null : OPEN_BALANCES_SUMMARY_KEY,
    () => OrderService.getOpenBalancesSummary(),
    {
      refreshInterval: 300000,
    },
  );
  return { summary: data, mutateSummary: mutate };
};
